import './index.scss'
import { __ } from '@wordpress/i18n';
import  ResetAttributes  from '../../../general/ResetButton.js'
import classnames from 'classnames';
import { useState, useEffect } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { InspectorControls,	BlockControls, } from '@wordpress/block-editor';
import {	
	PanelBody,	
	Button,
	ToggleControl,
	Flex, FlexItem,
	ButtonGroup
} from '@wordpress/components';
import { useSelect } from '@wordpress/data';


const allowedBlocks = [ 'core/heading', 'core/paragraph', 'core/list', 'core/post-excerpt'  ];


const addAttributes = ( settings, name ) => {		

	if ( !allowedBlocks.includes( name ) ) return settings;

	if( typeof settings.attributes !== 'undefined' ) {		
		settings.attributes = {
			...settings.attributes,
			atext: {
				type: 'object',
				default: {					
					aOn: false,
					textAlignList: ['', '', ''],
				}
			}
		}		 
	}

	return settings;
}


const addAttributes2 = ( settings, name ) => {
	
	if ( ! allowedBlocks.includes( name ) ) {
		return settings;
	}	

	if( typeof settings.attributes !== 'undefined' ){	
    settings.attributes = Object.assign(settings.attributes, {
			textAlignList:{ 
				type: 'array',
				default: ['', '',''],
			},		
			textAlignCheck:{
				type: 'boolean',
				default: false
			}
		})
	}
	return settings;
}


const addInspectorControl = ( BlockEdit ) => ( props ) => {

	if ( ! allowedBlocks.includes( props.name ) ) {
		return ( <BlockEdit { ...props } /> );
	}

	const {	attributes, setAttributes, isSelected } = props;
	const {	atext = {} } = attributes;
	const { 
		aOn,	
		textAlignList 
	} = atext;

	const defaultPosition = {
		aOn: false,
		textAlignList: ['', '', ''],
	};
	const isDifferentFromDefault = JSON.stringify({ ...atext, aOn: undefined }) !== JSON.stringify({ ...defaultPosition, aOn: undefined });

	const updateObject = (obj, key, newVal) => ({ ...obj, [key]: newVal });
	const updateArray = (list, index, newVal) => {
		const listsCopy = [...list];
		listsCopy[index] = newVal;
		return listsCopy;
	}

	const reset = () => {	setAttributes({ atext: {...atext,	textAlignList: ['', '', '']	}});	};

	const [syncViewport, setSyncViewport] = useState(false);
	const [breakPoint, setBreakPoint] = useState(0);

	useEffect(() => {
		const update = () => {
			let temp = 'Desktop';
			if (breakPoint === 1) temp = 'Tablet';
			if (breakPoint === 2) temp = 'Mobile';
			if (syncViewport) wp.data.dispatch('core/editor').setDeviceType(temp);
		};
		update();
	}, [syncViewport, breakPoint]);


	return (
		<>
			{/* <BlockControls
				controls={ [
					{
						icon: 'screenoptions',
						title: __( 'Responsive Text Align', 'aver' ),
						onClick: ()=> setAttributes( { textAlignCheck: !textAlignCheck } ),
						isActive: textAlignCheck,
					},
				] }
			></BlockControls> */}


			<BlockEdit { ...props } />

				{ isSelected  && <>					
					<InspectorControls group="settings">
						<PanelBody title={ __( 'Responsive Text Align', 'aver' ) } initialOpen={ aOn }>
							<Flex direction="column"> 
								
								<Flex>
									<FlexItem>
										<ToggleControl
											label={ __( 'Enable Text Align', 'aver' ) }
											checked={ aOn }
											onChange={(val) => setAttributes({ atext: {...atext, aOn: val }})}								
										/>
									</FlexItem>
									<FlexItem>
										{ isDifferentFromDefault && (
											<ResetAttributes
												onConfirm={() => {
													setAttributes({
														atext: {
															aOn: false,
															textAlignList: ['', '', ''],							
														},
													});								
												}}
											/> 
										)}
									</FlexItem>
								</Flex>									

								{ aOn && 
									<Flex direction="column" gap={4}>
							
										<Flex>
											<FlexItem className="button-frame">
												<Button icon="welcome-view-site" label="Sync Viewport" onClick={() => setSyncViewport(!syncViewport)}	isPressed={syncViewport} />
												<Button icon="undo"	label="Reset All"	onClick={reset}	/>
											</FlexItem>
											<FlexItem className="button-frame">
												<Button	icon="desktop" isPressed={breakPoint === 0}	onClick={() => setBreakPoint(0)} label=">1024px" />
												<Button icon="tablet"	isPressed={breakPoint === 1} onClick={() => setBreakPoint(1)}	label="≥782px" />
												<Button	icon="smartphone"	isPressed={breakPoint === 2} onClick={() => setBreakPoint(2)}	label="<782px"/>
											</FlexItem>
										</Flex>

											<Flex>						
											<FlexItem className="button-frame">
												<Button
													icon="editor-alignleft"
													isPressed={textAlignList[breakPoint] === 'left'}
													onClick={() =>
														setAttributes({
															atext: {
																...atext,
																textAlignList: updateArray(textAlignList, breakPoint, 'left'),
															},
														})
													}
												/>
												<Button
													icon="editor-aligncenter"
													isPressed={textAlignList[breakPoint] === 'center'}
													onClick={() =>
														setAttributes({
															atext: {
																...atext,
																textAlignList: updateArray(textAlignList, breakPoint, 'center'),
															},
														})
													}
												/>
												<Button
													icon="editor-alignright"
													isPressed={textAlignList[breakPoint] === 'right'}
													onClick={() =>
														setAttributes({
															atext: {
																...atext,
																textAlignList: updateArray(textAlignList, breakPoint, 'right'),
															},
														})
													}
												/>
												<Button
													icon="menu-alt3"
													isPressed={!textAlignList[breakPoint]}
													onClick={() =>
														setAttributes({
															atext: {
																...atext,
																textAlignList: updateArray(textAlignList, breakPoint, ''),
															},
														})
													}
												/>
											</FlexItem>	
											</Flex>							
										

									</Flex>
								}
			
							</Flex>	
						</PanelBody>
					</InspectorControls></>
				}

		</>
	)
}


const applyExtraClassEditor = ( BlockListBlock ) => ( props ) => {

	if ( ! allowedBlocks.includes( props.name ) ) {
		return 	<BlockListBlock { ...props } />			
	}

	const { attributes, wrapperProps, className } = props;	
	const { atext = {} } = attributes;
	const { aOn, textAlignList	} = atext;

	
	if (!aOn) return <BlockListBlock {...props} />;

	const currentDevice = useSelect((select) => {
		return select( 'core/editor' ).getDeviceType();
	}, []);
	const breakPoint = { Desktop: 0, Tablet: 1, Mobile: 2 }[currentDevice];

	const getFallback = (list, index) => {
		if (list?.[index] !== undefined && list[index] !== '') return list[index];
		if (index === 2 && list?.[1] !== '') return list[1];
		if (index === 2 && list?.[0] !== '') return list[0];
		if (index === 1 && list?.[0] !== '') return list[0];
		return '';
	};

	const cssstyle = { 
		...wrapperProps?.style,
	}		
	

	const classes = classnames(
		className, ``,
		{
			[`align-text-${getFallback(textAlignList, breakPoint)}`]: textAlignList[breakPoint],
		}
	)

	if ( JSON.stringify( textAlignList)  == JSON.stringify( ['','','']) ) {
		return <BlockListBlock	{ ...props } />
	}
		
	return (
		<BlockListBlock
			{ ...props }
			wrapperProps={ { style : cssstyle } } 	
			className={ classes }
		/>
	)

}




const applyExtraClassSave = ( extraProps, blockType, attributes ) => {

	if (!allowedBlocks.includes(blockType?.name)) {
    return extraProps;
  }
	
	const { textAlignList } = attributes;
	const { className } = extraProps;

	let cssstyle = extraProps.style ? { ...extraProps.style } : {};
	let darray = {}

	const classes = classnames( 
		className
	)	

	if ( typeof textAlignList == 'undefined' ) {
		return extraProps;
	}
	
	if ( JSON.stringify( textAlignList)  == JSON.stringify( ['','','']) ) {
		return extraProps;
	}

	if ( ( typeof textAlignList != 'undefined' )  && ( JSON.stringify( textAlignList)  != JSON.stringify( block.attributes.textAlignList.default) )) {
		let parray = {'data-has-text-align': JSON.stringify(textAlignList) }	
		darray = { ...darray, ...parray }		
	}

	return {
		...extraProps, 
		...darray, 
		style:  cssstyle,
		className: classes
	}
}


addFilter(
	'blocks.registerBlockType',
	'aver/textalign-attributes',
	addAttributes
);

addFilter(
	'editor.BlockEdit',
	'aver/textalign-advanced-control',
	addInspectorControl
);

addFilter(
	'editor.BlockListBlock',
	'aver/textalign-editor-class',
	applyExtraClassEditor,
);

// front end save function
// Comment out to use render_block approach
//addFilter(	'blocks.getSaveContent.extraProps',	'aver/textalign-save-class',	applyExtraClassSave  );
